(() => {
  const WINDOW_CLOSED_POLL_INTERVAL = 500;

  const DEFAULT_WIDTH = 600;
  const DEFAULT_HEIGHT = 460;

  const PAYMENT_COMPLETE_EVENT = 'paymentComplete';

  const OPEN_POP_UP_FAIL_REASON = 'OPEN_POP_UP_FAIL';

  window.SCC2PaymentPage = function (settings) {
    this.settings = settings || {};
    this.baseUrl = null;
    this.scc2PaymentWindow = null;
    this.reject = null;
    this.resolve = null;
    this.interval = null;
    this.closeTimeout = null;
    this.openedAt = null;
    this.popupUrl = null;

    this.open = (params) => {
      this.reset();

      return new Promise((resolve, reject) => {
        try {
          this.reject = reject;
          this.resolve = resolve;

          this._doOpen(params);
        } catch (e) {
          reject(e);
        }
      });
    };

    this.focus = () => {
      const ua = navigator.userAgent;
      if (/iPad|iPhone|iPod/.test(ua)) {
        alert(this.settings.text.iosFocus);
      }
      this.scc2PaymentWindow.focus();
    };

    this.close = (reason) => {
      if (this.reject) {
        this.reject(new Error(reason instanceof window.Event ? this._describeEvent(reason) : reason));
      }
      this.reset();
      if (!reason) {
        this.settings.onCancel?.();
      }
    };

    this._doOpen = (params) => {
      const url = this._buildUrl(params);
      this.popupUrl = url;

      try {
        this.scc2PaymentWindow = window.open(url, '_blank', this._buildWindowFeatures());
        this.openedAt = Date.now();

        if (!this.scc2PaymentWindow || this.scc2PaymentWindow.closed) {
          this.close(OPEN_POP_UP_FAIL_REASON);
          return;
        }
        if (window.focus) {
          this.scc2PaymentWindow.focus();
        }
        this.settings.onStart?.();
      } catch {
        this.close(OPEN_POP_UP_FAIL_REASON);
        return;
      }

      window.addEventListener('beforeunload', this.close);
      window.addEventListener('unload', this.close);
      window.addEventListener('pagehide', this.close);
      window.addEventListener('popstate', this.close);

      this.baseUrl = params.url;

      window.addEventListener('message', this._handleMessage);

      this.interval = window.setInterval(() => {
        if (this.scc2PaymentWindow && this.scc2PaymentWindow.closed) {
          /** Give the queued paymentComplete postMessage one last chance to resolve
                before treating a just-closed popup as a cancel/failure. */
          window.clearInterval(this.interval);
          this.interval = null;
          this.closeTimeout = window.setTimeout(() => {
            if (this.scc2PaymentWindow && this.scc2PaymentWindow.closed) {
              this.close();
            }
          }, WINDOW_CLOSED_POLL_INTERVAL);
        }
      }, WINDOW_CLOSED_POLL_INTERVAL);
    };

    this._handleMessage = (event) => {
      if (event.origin !== this.baseUrl) {
        return;
      }

      if (event.data.eventType === PAYMENT_COMPLETE_EVENT) {
        const resolve = this.resolve;

        this.reset();

        if (resolve) {
          resolve(event.data.result);
        }
      }
    };

    /** MLC-13459 diagnostics: why some iOS devices fire pagehide right after window.open.
          Keeps the "[object PageTransitionEvent]" prefix so existing Splunk searches still match. */
    this._describeEvent = (event) => {
      const details = {
        type: event.type,
        persisted: event.persisted,
        visibilityState: document.visibilityState,
        hasFocus: document.hasFocus(),
        msSinceOpen: Date.now() - this.openedAt,
        popupClosed: this.scc2PaymentWindow?.closed,
        standalone: navigator.standalone,
        historyLength: window.history.length,
        // origin only: full referrer URLs can carry email-tracking params
        referrer: document.referrer && new URL(document.referrer).origin
      };
      return `${this.popupUrl} ${event} ${JSON.stringify(details)}`;
    };

    this._buildUrl = (params) => {
      const { url: baseUrl, ...searchParams } = params;

      const url = new URL('/', baseUrl);

      url.search = new URLSearchParams(searchParams);

      return url.toString();
    };

    this._buildWindowFeatures = () => {
      const screenLeft = typeof window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
      const screenTop = typeof window.screenTop !== 'undefined' ? window.screenTop : screen.top;

      const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
      const height = window.innerHeight || document.documentElement.clientHeight || screen.height;

      const left = screenLeft + (width / 2 - DEFAULT_WIDTH / 2);
      const top = screenTop + (height / 2 - DEFAULT_HEIGHT / 2);

      return `scrollbars=yes, width=${DEFAULT_WIDTH}, height=${DEFAULT_HEIGHT}, top=${top}, left=${left}`;
    };

    this.reset = () => {
      this.baseUrl = null;
      if (this.scc2PaymentWindow) {
        this.scc2PaymentWindow.close();
      }

      window.removeEventListener('popstate', this.close);
      window.removeEventListener('message', this._handleMessage);
      window.clearInterval(this.interval);
      window.clearTimeout(this.closeTimeout);

      this.scc2PaymentWindow = null;
      this.reject = null;
      this.resolve = null;
      this.interval = null;
      this.closeTimeout = null;
    };
  };
})();
